import { MapTo } from '@adobe/aem-react-editable-components';
import FundingModule, { FundingEditConfig } from './FundingModule';

export default MapTo('cob-corp-acquisition/components/creditonebank/funding-module')(FundingModule, FundingEditConfig);